import React from 'react'
import ReactDOM from 'react-dom'
import 'focus-visible';

import { SearchParamsRouterProvider } from './utils/search-params-router'
import { ErrorsDisplay, ErrorsProvider }from './common-components/errors'
import reportWebVitals from './reportWebVitals'
import AppLoader from './app-loader'
import ServiceWorker from './common-components/service-worker'
import './locales/i18n'

import './styles/index.scss'


ReactDOM.render([

  <React.StrictMode>
    <SearchParamsRouterProvider>
      <ServiceWorker />
      <ErrorsProvider>
        <ErrorsDisplay />
        <AppLoader />
      </ErrorsProvider>
    </SearchParamsRouterProvider>
  </React.StrictMode>,

  <div className="build-date">
    {(process.env.REACT_APP_BUILD_DATE || '').replace(/_/g, ' ')}
  </div>

], document.getElementById('root'))


// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
